import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PasswordResetPage, CustomBrandLogo } from "@ippon/shared-auth";
import { api, type ApiError } from "@ippon/shared-utils";

const Otp: React.FC = () => {
  const navigate = useNavigate();
  const email =
    typeof window !== "undefined" ? localStorage.getItem("email") : null;

  useEffect(() => {
    if (!email) {
      navigate("/login", { replace: true });
    }
  }, [email, navigate]);

  if (!email) return null;

  return (
    <PasswordResetPage
      renderLogo={<CustomBrandLogo />}
      email={email}
      onSubmit={async ({ otp, password, confirmPassword }) => {
        if (password !== confirmPassword) {
          return { ok: false, message: "パスワードが一致しません" };
        }

        try {
          await api.post("/auth/reset-password", {
            email,
            verificationCode: otp,
            newPassword: password,
          });

          localStorage.removeItem("otp");
          localStorage.removeItem("email");
          navigate("/reset-success", { replace: true });
          return { ok: true };
        } catch (e) {
          const err = e as ApiError;
          return {
            ok: false,
            message: err.message || "認証コードが正しくありません。",
          };
        }
      }}
      onResend={async () => {
        try {
          const res = await api.post("/auth/check-mail", { email });
          if (res.status === 200) return { ok: true };
          return { ok: false, message: "再送に失敗しました" };
        } catch (e) {
          const err = e as ApiError;
          return { ok: false, message: err.message };
        }
      }}
    />
  );
};

export default Otp;
